import React from 'react';
import { Sparkles } from 'lucide-react';

const EmptySkillsState = () => (
  <div className="rounded-2xl border border-dashed border-purple-300/30 bg-slate-950/40 px-5 py-8 text-center">
    <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-2xl bg-purple-500/20 text-purple-200">
      <Sparkles className="h-6 w-6" />
    </div>
    <p className="mt-4 text-sm font-semibold text-white">No reviewed skills yet</p>
    <p className="mt-1 text-sm text-slate-400">Save a profile, upload a resume, or add skills manually.</p>
  </div>
);

export default EmptySkillsState;

